var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 200 100"}},[_c('path',{attrs:{"d":"M195 35L84.68 5L84.68 35L5 13.57L115.32 95L115.32 52.14L195 82.14L195 35Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }